import { mapState, mapGetters } from 'vuex';
import apiService from '@/services/apiService';
import EmptyState from '@/components/core/emptyState.vue';
import CoreN20Card from '@/components/core/n20Card.vue';
import CoreHeader from '@/components/core/header.vue';
import CoreButton from '@/components/core/button.vue';
import CoreAccountFilter from '@/components/core/accountFilter.vue';
import DateTimeMixin from '@/mixins/date-time';
import DigitalTwinTemplateCreateDialog from '@/components/core/TwinTemplates/CreateDialog.vue';
function mergeLazyLoadedNodes(tree, newNodes) {
  const cloneTree = nodes => nodes.map(n => ({
    ...n,
    children: n.children ? cloneTree(n.children) : null
  }));
  const newTree = cloneTree(tree);
  const insertNodeByParentId = (nodes, parentId, childNode) => {
    return nodes.map(node => {
      if (node.id === parentId) {
        return {
          ...node,
          children: [...node.children, childNode]
        };
      }
      if (node.children && node.children.length > 0) {
        return {
          ...node,
          children: insertNodeByParentId(node.children, parentId, childNode)
        };
      }
      return node;
    });
  };
  let result = newTree;
  for (const node of newNodes) {
    if (!node.parentId) {
      // Add root level node if it doesn't exist
      if (!result.some(n => n.id === node.id)) {
        result = [...result, node];
      }
      continue;
    }
    result = insertNodeByParentId(result, node.parentId, node);
  }
  return result;
}
export default {
  name: 'DigitalTwinTemplatesOverview',
  components: {
    EmptyState,
    CoreN20Card,
    CoreHeader,
    CoreButton,
    CoreAccountFilter,
    DigitalTwinTemplateCreateDialog
  },
  mixins: [DateTimeMixin],
  data() {
    return {
      showDialogCreate: false,
      accountFilterIsReady: false,
      setSelectedAccounts: [],
      templates: [],
      searchString: '',
      isSearching: false,
      openNodes: [],
      activeNodes: [],
      selectedTemplate: null
    };
  },
  computed: {
    ...mapGetters('app', ['getAccountById']),
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color']),
    isEmpty() {
      var _this$templates;
      return ((_this$templates = this.templates) === null || _this$templates === void 0 ? void 0 : _this$templates.length) === 0;
    }
  },
  watch: {},
  mounted() {
    this.fetchTemplates();
  },
  methods: {
    async fetchTemplates() {
      const response = await apiService.digitalTwinTemplates.fetchTemplates({
        tenantIds: this.setSelectedAccounts,
        limit: 100,
        offset: 0,
        level: 3
      });
      this.templates = response.children;
      this.activeNodes = [this.templates[0]];
      this.handleActiveUpdate(this.templates);
    },
    handleActiveUpdate(ids) {
      this.selectedTemplate = ids[0];
    },
    async loadChildren(item) {
      const res = await apiService.digitalTwinTemplates.fetchTemplates({
        parentId: item.id
      });
      this.templates = mergeLazyLoadedNodes(this.templates, res.children);
    },
    handleSearchInput(value) {
      this.searchString = value;
    },
    handleShowDialogCreate() {
      this.showDialogCreate = true;
    },
    handleCloseDialogCreate() {
      this.showDialogCreate = false;
    },
    handleAccountFilterReady() {
      this.accountFilterIsReady = true;
    },
    handleAccountFilterChange(accounts) {
      this.setSelectedAccounts = accounts;
    },
    handleSaveDialogCreate(data) {
      const parentId = this.activeNodes[0];
      apiService.digitalTwinTemplates.createTemplate({
        ...data,
        parentId: parentId
      });
      this.fetchTemplates();
      this.handleCloseDialogCreate();
    }
  }
};